import React, {useEffect, useRef, useState} from 'react';
import "./ArtPage.css"
import {Modal, Row} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import ben from "./img/ben.png"
import jane from "./img/jane.png"
import aylwin from "./img/alywin.png"
import g1 from "./img/g1.png"
import g2 from "./img/g2.png"
import g3 from "./img/g3.png"
import g4 from "./img/g4.png"
import g5 from "./img/g5.png"
import g6 from "./img/g6.png"
import g7 from "./img/g7.png"
import g8 from "./img/g8.png"
import o1 from "./img/o1.png"
import o2 from "./img/o2.png"
import o3 from "./img/o3.png"
import o4 from "./img/o4.png"
import o5 from "./img/o5.png"
import o6 from "./img/o6.png"
import o7 from "./img/o7.png"
import o8 from "./img/o8.png"
import l1 from "./img/l1.png"
import l2 from "./img/l2.png"
import l3 from "./img/l3.png"
import l4 from "./img/Art Institute of Chicago.png"
import l5 from "./img/National Gallery of Art.png"
import l6 from "./img/Rijksmuseum.png"
import l7 from "./img/l7.png"
import l8 from "./img/l8.png"
import {
    artistInterviewVideos,
    getArtistInterviewEmbedUrl,
    getYouTubeOEmbedData,
    getYouTubeThumbnailUrl
} from "../Artists/artistInterviews";

const titleImg = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Gerardo+Ibarra/Featured+Image+-+Kemelyen.png";
const a1 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/1+-+Jonathan+Armour.webp";
const a2 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/2+-+Ke+Yang.webp";
const a3 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/3+-+Lucy+Nelson.webp";
const a4 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/4+-+Jo+Vincent.webp";
const a5 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/5+-+Jenette+Coldrick.webp";
const a6 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/BarbaraSafrandeNiverville/Autumn+Equinox_square.webp";
const a7 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Christian+Redermaye.webp";
const a8 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/8+-+Doris+Luming.webp";
const a9 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/9+-+Linwang+Wang.webp";
const a11 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/11+-+Richard+Battye.webp";
const a12 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/12+-+Guille+Giagante.webp";
const a14 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/15+-+Rory+Watson.webp";
const a15 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/16+-+Caitlin+Flood-Molyneux.webp";
const a16 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/14+-+Ant+Webb.webp";
const a17 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Angelique+Cover+Image.webp";
const a18 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/18+-+Ethan+Platt.webp";
const a20 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/19+-+Alexander+Rhys.webp";
const a21 = "https://d1mluz1pfkw29o.cloudfront.net/img/Artists/20+-+Paul+Gittins.webp";
const a22 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/hyy.png';
const a23 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Kemelyen+1.png';
const a24 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Camping+on+Country.jpg';
const a25 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/MTesoro_DuckBills_PaleYellow.jpg';
const a26 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Crypto+Polka_Square+Crop.jpg';
const a27 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Painted+Lady+Studio/Kamala+Purple_Square+Crop.jpg';
const a28 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Rachel+Sheree/Cloudy+Clouds_Square+Crop.jpg';
const a29 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/20-Guillermina+Etchebarne/2.+Artist+photo/VN-GE-Square.jpg';
const a30 = 'https://d1mluz1pfkw29o.cloudfront.net/img/Artists/Michael+Isles.png';
const a31 = 'https://vieunite-website.s3.eu-west-1.amazonaws.com/img/Artists/Fred+Garwood/VN-FG-Square.jpg';
const a32 = 'https://vieunite-website.s3.eu-west-1.amazonaws.com/img/Artists/Willis+Designs/VN-WD-Square.jpg';
const a33 = 'https://vieunite-website.s3.eu-west-1.amazonaws.com/img/Artists/Josh+Bowe/VN-JB-Square.jpg';
const artTabs = [
    {key: 'artists', label: 'ARTISTS'},
    {key: 'galleries', label: 'GALLERIES'},
    {key: 'curation', label: 'CURATION TEAM'},
    {key: 'videos', label: 'VIDEOS'},
];

function ArtPage() {
    // const {page} = useParams();
    const currentOrigin = window.location.origin;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const initialVideosList = artistInterviewVideos.map((item) => ({
        ...item,
        thumbnail: getYouTubeThumbnailUrl(item.url),
        embedUrl: getArtistInterviewEmbedUrl(item.name),
        title: `Artist Interview with ${item.name}`
    })).filter((item) => item.thumbnail && item.embedUrl);

    const [videosList, setVideosList] = useState(initialVideosList);
    const [selectedVideo, setSelectedVideo] = useState(null);

    const openVideoModal = (video) => {
        setSelectedVideo(video);
    };

    const closeVideoModal = () => {
        setSelectedVideo(null);
    };

    // artists
    const myRef = useRef(null);

    const ArtistsList = [{
        'name': 'Paul Gittins',
        img: a21,
        'path': '/featuredartists/paul-gittins'
    }, {'name': 'Alexander Rhys', 'img': a20, 'path': `/featuredartists/alexander-rhys`}, {
        'name': 'Ethan Platt',
        'img': a18,
        'path': '/featuredartists/ethan-platt'
    },  {
        'name': 'Angelique Nagovskaya',
        'img': a17,
        'path': '/featuredartists/angelique-nagovskaya'
    }, {
        'name': 'Caitlin Flood-Molyneux',
        'img': a15,
        'path': '/featuredartists/caitlin-flood-molyneux'
    }, {
        'name': 'Jonathan Armour',
        'img': a1,
        'path': '/featuredartists/jonathan-armour'
    }, {
        'name': 'Barbara Safran de Niverville',
        'img': a6,
        'path': '/featuredartists/barbara-safran-de-niverville'
    }, {
        'name': 'Richard Battye',
        'img': a11,
        'path': '/featuredartists/richard-battye'
    }, {
        'name': 'Christian Redermayer',
        'img': a7,
        'path': '/featuredartists/christian-redermayer'
    }, {'name': 'Lucy Nelson', 'img': a3, 'path': '/featuredartists/lucy-nelson'}, {
        'name': 'Rory Watson',
        'img': a14,
        'path': '/featuredartists/rory-watson'
    }, {'name': 'Anthony Webb', 'img': a16, 'path': '/featuredartists/anthony-webb'}, {
        'name': 'Jo Vincent',
        'img': a4,
        'path': '/featuredartists/jo-vincent'
    }, {'name': 'Guille Giagante', 'img': a12, 'path': '/featuredartists/guille-giagante'}, {
        'name': 'Jenette Coldrick',
        'img': a5,
        'path': '/featuredartists/jenette-coldrick'
    }, {
        'name': 'Ke Yang',
        'img': a2,
        'path': '/featuredartists/ke-yang'
    }, // {'name': 'David Bickley', 'img': a10, 'path': '/featuredartist/davidbickley'},
        {'name': 'Doris Luming', 'img': a8, 'path': '/featuredartists/doris-luming'},
        {
            'name': 'Linwang Wang',
            'img': a9,
            'path': '/featuredartists/linwang-wang'
        },
        {'name': 'Hu Yuanyuan', 'img': a22, 'path': '/featuredartists/huyuanyuan'},
        {'name': 'Kemelyen', 'img': a23, 'path': '/featuredartists/kemelyen'},
        {'name': 'Julianne Wade', 'img': a24, 'path': '/featuredartists/juliannewade'},
        {'name': 'Marta Tesoro', 'img': a25, 'path': '/featuredartists/MartaTesoro'},
        {'name': 'Neis Wai', 'img': a26, 'path': '/featuredartists/NeisWai'},
        {'name': 'Painted Lady Studio', 'img': a27, 'path': '/featuredartists/PaintedLadyStudio'},
        {'name': 'Rachel Sheree', 'img': a28, 'path': '/featuredartists/RachelSheree'},
        {'name': 'Guillermina Etchebarne', 'img': a29, 'path': '/featuredartists/GuillerminaEtchebarne'},
        {'name': 'Michael Isles', 'img': a30, 'path': '/featuredartists/MichaelIsles'},
        {'name': 'Fred Garwood', 'img': a31, 'path': '/featuredartists/FredGarwood'},
        {'name': 'Willis Designs', 'img': a32, 'path': '/featuredartists/WillisDesigns'},
        {'name': 'Josh Bowe', 'img': a33, 'path': '/featuredartists/JoshBowe'},
    ]



    const activeCharacters = new Set(ArtistsList.map(artist => artist.name.split(' ').pop().charAt(0)))

    const filters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    const sortedArtists = ArtistsList.sort((a, b) => {
        return a.name.split(' ').pop().localeCompare(b.name.split(' ').pop());
    });

    const [artists, setArtists] = useState(sortedArtists);
    const [filter, setFilter] = useState(null);

    const navigate = useNavigate();
    const getActiveKey = () => {
        return queryParams.get('page') ? queryParams.get('page') : "artists";
    };
    const activeTab = getActiveKey();
    const handleTabChange = (key) => {
        navigate(`/art?page=${key}`)
    };

    function filterArtistsByFirstLetter(n) {
        if (filter === n) {
            setFilter('')
            setArtists(ArtistsList.filter(artist => artist.name.split(' ').pop().startsWith('')));
        } else {
            setFilter(n);
            setArtists(ArtistsList.filter(artist => artist.name.split(' ').pop().startsWith(n)));
        }
        if (myRef.current) {
            myRef.current.scrollIntoView({behavior: 'instant'});
        }
    }

    // galleries
    const galleryList = [
        {
            'preview': g2,
            'logo': l2,
            'description': 'The National Galleries of Scotland collection showcases well-known ' + 'and hidden gems from Scotland\'s internationally leading art collection. Discover and admire masterpieces ' + 'from legendary artists such as Leonardo da Vinci, Sandro Botticelli, and Thomas Gainsborough, or get to know ' + 'the extraordinary personalities depicted in paintings by John Singer Sargent and Sir Henry Raeburn. ' + 'If you are a fan of vivid colours, you can lose yourself in the works of Samuel John Peploe and Edouard Vuillard. ' + 'No matter what your preference, there is something for everyone in this world-class art collection',
            'website': "https://www.nationalgalleries.org/",
            'details': "/galleries/national-galleries-scotland"
        },
        {
            'preview': g3,
            'logo': l3, // 'description': 'The Estorick Collection of Modern Italian Art opened in London in 1998. ' +
            //     'A Grade II listed Georgian town house, it was originally restored with support from the Heritage Lottery Fund. ' +
            //     'Further recent renovations have opened up the space of the ground-floor entranceway, bookshop and café, ' +
            //     'while its six galleries and art libraryhave also been fully upgraded. The Collection is known internationally for its core of  Futurist works,' +
            //     ' as well as figurative art and sculpture dating from 1890 to the 1950s. The exhibition programme continues to address ' +
            //     'artists, movements, and questions in ways  that change our understanding of Italian art and culture.',
            // 'description': 'The Estorick Collection of Modern Italian Art is internationally renowned for its core of Futurist works. ' +
            //     'It comprises some 120 paintings, drawings, watercolours, prints and sculptures by many of the most prominent Italian artists of the modernist era. ' +
            //     'There are six galleries, two of which are used for temporary exhibitions. Since opening in 1998, the Estorick has established a reputation and gained critical acclaim as a key venue for bringing Italian art to the British public.',
            'description': 'The Estorick Collection of Modern Italian Art is a renowned London museum housed in a beautiful Georgian building. It boasts an internationally acclaimed collection of Futurist works, alongside figurative art and sculpture dating from 1890 to the 1950s. With six galleries, two dedicated to temporary exhibitions, the Estorick offers a dynamic programme showcasing the best of Italian art. Explore masterpieces by prominent Italian modernists, including paintings and drawings by Umberto Boccioni, Luigi Russolo, Amedeo Modigliani, and sculptures by Medardo Rosso.',
            'website': "https://www.estorickcollection.com/",
            'details': "/galleries/estorick-collection"
        },
        {
            'preview': g1,
            'logo': l1, // 'description': 'The Royal Birmingham Society of Artists (RBSA) is an artist-led' +
            //     ' charity in Birmingham, UK. Over the two hundred years of its existence, it has built up an archive of ' +
            //     'work created by its many illustrious artist members.',
            'description': 'The Royal Birmingham Society of Artists (RBSA) is an artist-led charity based in the Jewellery Quarter in Birmingham, UK. Over the two hundred years of its existence, it has built up an archive of wonderful work created by its many illustrious artist members, including such luminaries as Joseph Edward Southall, Joseph Barber, Edward Samuel Harper, and Arthur Charles Shorthouse.',
            'website': "https://rbsa.org.uk/",
            'details': "/galleries/rbsa-gallery"
        },
        {
            'preview': g7,
            'logo': l7,
            'description': 'The Royal Pavilion at Brighton is King George IV\'s spectacular party palace by the sea.' + 'Built in India and Chinese-style with onion domes and minarets, it is a riot of colour and exoticism both inside and out.',
            'website': "https://brightonmuseums.org.uk/visit/royal-pavilion-garden/",
            'details': "/galleries/RoyalPavilion"
        },
        {
            'preview': g4,
            'logo': l4,
            'description': 'The Art Institute of Chicago is a cultural landmark renowned for ' + 'its world-class collection and commitment to artistic excellence. With its rich and diverse collection, ' + 'the Art Institute of Chicago continues to inspire and  engage art enthusiasts from around the world.',
            'website': "https://www.artic.edu/",
            'details': "/galleries/art-institute-of-chicago"
        },
        {
            'preview': g5,
            'logo': l5,
            'description': 'The National Gallery of Art in Washington, D. C. is a renowned ' + 'institution that showcases an impressive collection of artistic masterpieces spanning centuries. ' + 'With its commitment to fostering cultural appreciation and education, the National Gallery of Art is a ' + 'leading international institution.',
            'website': "https://www.nga.gov/",
            'details': "/galleries/national-gallery-of-art"
        },
        {
            'preview': g6,
            'logo': l6,
            'description': 'The Rijksmuseum is the national museum of the Netherlands. ' + 'It houses world-famous  masterpieces from the Dutch Golden Age, including Vermeer\'s "The Milkmaid" ' + 'and  Rembrandt\'s "Night Watch". The museum itself is also a masterpiece,  with its stunning building ' + 'and remarkable interior design. In 80 galleries,  8,000 objects tell the story of 800 years of Dutch history.',
            'website': "https://www.rijksmuseum.nl/en",
            'details': "/galleries/rijksmuseum"
        },
        {
            'preview': g8,
            'logo': l8,
            'description': 'The Nasjonalmuseet is Norway\'s premier showcase for art and design. Known in English as the National Museum, it was established in 1842 and recently relocated to a stunning new building. The museum houses a vast collection spanning 3,000 years. Discover Norwegian masterpieces like Edvard Munch\'s The Scream alongside works by international artists such as Picasso, Renoir, and El Greco. Explore a rich tapestry of creativity, from ancient artefacts to contemporary design, all under one roof.',
            'website': "https://www.nasjonalmuseet.no/",
            'details': "/galleries/TheNasjonalMuseet"
        },
    ]

    const [isSticky, setIsSticky] = useState(false);
    const firstGalleryRef = useRef(null);
    const secondGalleryRef = useRef(null);
    const thirdGalleryRef = useRef(null);
    const fourthGalleryRef = useRef(null);
    const fifthGalleryRef = useRef(null);
    const sixthGalleryRef = useRef(null);
    const seventhGalleryRef = useRef(null);
    const eighthGalleryRef = useRef(null);
    const galleryRefs = [firstGalleryRef, secondGalleryRef, thirdGalleryRef, fourthGalleryRef, fifthGalleryRef, sixthGalleryRef, seventhGalleryRef, eighthGalleryRef]
    const [distance, setDistance] = useState(0);

    const handleScroll = () => {
        const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
        if (firstGalleryRef.current) {
            const rect2 = secondGalleryRef.current.getBoundingClientRect();

            const rect3 = thirdGalleryRef.current.getBoundingClientRect();

            const rect4 = fourthGalleryRef.current.getBoundingClientRect();

            const rect5 = fifthGalleryRef.current.getBoundingClientRect();

            const rect6 = sixthGalleryRef.current.getBoundingClientRect();

            const rect7 = seventhGalleryRef.current.getBoundingClientRect();

            const rect8 = eighthGalleryRef.current.getBoundingClientRect();

            const rect = firstGalleryRef.current.getBoundingClientRect();

            const offset = rect8.top - rect.top

            const threshold = galleryList.length * rootFontSize;
            // const effectiveArea = 30 * rootFontSize
            // const passed = rect.toString()
            if (rect3.top > 0) {
                setDistance(0)
                setIsSticky(rect.top < threshold)
                console.log(rect.top + ":" + threshold)
            } else {
                setDistance(Math.round(offset))
                console.log("distance: " + distance)
                setIsSticky(rect8.top > threshold)
            }

            const changeSrcOffset = -window.innerHeight * 0.5;
            let imgSrc = g2
            // const changeSrcOffset = -300
            if (rect8.top + changeSrcOffset < 0) {
                imgSrc = g8
            } else if (rect7.top + changeSrcOffset < 0) {
                imgSrc = g6
                // changeImage(g6)
            } else if (rect6.top + changeSrcOffset < 0) {
                imgSrc = g5
                // changeImage(g5)
            } else if (rect5.top + changeSrcOffset < 0) {
                imgSrc = g4
                // changeImage(g4)
            } else if (rect4.top + changeSrcOffset < 0) {
                imgSrc = g7
                // changeImage(g6)
            } else if (rect3.top + changeSrcOffset < 0) {
                imgSrc = g1
                // changeImage(g1)
            } else if (rect2.top + changeSrcOffset < 0) {
                imgSrc = g3
                // changeImage(g3)
            } else {
                imgSrc = g2
                // changeImage(g2)
            }

            setNextImageSrc(imgSrc)

        }
    };

    const [imageSrc, setImageSrc] = useState(g2);
    const [fade, setFade] = useState(false);
    const [nextImageSrc, setNextImageSrc] = useState(g2);
    // const [hoverImageSrc, setHoverImageSrc] = useState(null);
    useEffect(() => {
        if (nextImageSrc && nextImageSrc !== imageSrc) {
            setFade(true); // Trigger fade-out
            console.log("changing target " + nextImageSrc + " current: " + imageSrc)
            const timeoutId = setTimeout(() => {
                setImageSrc(nextImageSrc); // Change the image source after fading out
                setFade(false); // Trigger fade-in
            }, 250);

            return () => clearTimeout(timeoutId); // Clean up the timeout if component unmounts
        }
    }, [nextImageSrc]);

    const [isHoveringGallery, setIsHoveringGallery] = useState(false);
    useEffect(() => {
        console.log("changing target trigger effect hovering: " + isHoveringGallery + " imageSrc : " + imageSrc)
        if (isHoveringGallery) {
            if (imageSrc === g1 || imageSrc === o1) {
                setImageSrc(o1)
            } else if (imageSrc === g2 || imageSrc === o2) {
                setImageSrc(o2)
            } else if (imageSrc === g3 || imageSrc === o3) {
                setImageSrc(o3)
            } else if (imageSrc === g4 || imageSrc === o4) {
                setImageSrc(o4)
            } else if (imageSrc === g5 || imageSrc === o5) {
                setImageSrc(o5)
            } else if (imageSrc === g6 || imageSrc === o6) {
                setImageSrc(o6)
            } else if (imageSrc === g7 || imageSrc === o7) {
                setImageSrc(o7)
            } else if (imageSrc === g8 || imageSrc === o8) {
                setImageSrc(o8)
            }
        } else {
            if (imageSrc === o1 || imageSrc === g1) {
                setImageSrc(g1)
            } else if (imageSrc === o2 || imageSrc === g2) {
                setImageSrc(g2)
            } else if (imageSrc === o3 || imageSrc === g3) {
                setImageSrc(g3)
            } else if (imageSrc === o4 || imageSrc === g4) {
                setImageSrc(g4)
            } else if (imageSrc === o5 || imageSrc === g5) {
                setImageSrc(g5)
            } else if (imageSrc === o6 || imageSrc === g6) {
                setImageSrc(g6)
            } else if (imageSrc === o7 || imageSrc === g7) {
                setImageSrc(g7)
            } else if (imageSrc === o8 || imageSrc === g8) {
                setImageSrc(g8)
            }
        }
    }, [isHoveringGallery]);

    const onMouse = (over) => {
        if (!isSticky) {
            return
        }
        setIsHoveringGallery(over)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        // console.log("the list")
        // console.log([...activeCharacters])
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        let isCancelled = false;

        Promise.all(initialVideosList.map(async (video) => {
            try {
                const oEmbedData = await getYouTubeOEmbedData(video.url);

                return {
                    ...video,
                    title: oEmbedData.title || video.title,
                };
            } catch (error) {
                return video;
            }
        })).then((nextVideos) => {
            if (!isCancelled) {
                setVideosList(nextVideos);
            }
        });

        return () => {
            isCancelled = true;
        };
    }, []);

    const openBrochure = () => {
        window.open('https://vieunite.com/Become_a_Vieunite_Artist_Master.pdf', '_blank');
    };

    return (<div style={{backgroundColor: '#F0F0F0', minWidth: '1040px'}}>
        <div style={{height: '100vh', width: '100%', display: 'flex', flexDirection: 'row'}}>
            <div style={{width: '50%', height: '100%'}}>
                <img style={{width: '100%', height: '100%', objectFit: 'cover'}} src={titleImg}/>
            </div>
            <div style={{width: '50%', height: '100%', backgroundColor: '#CFCFCF'}}>
                <div style={{
                    paddingLeft: '4vw',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <p className={'art-title-subtitle'}>VIEUNITE FEATURED ARTIST</p>
                    <p className={'art-title-main'}>Kemelyen</p>
                    <button
                        className="homeMainButton black-border-hover-white"
                        onClick={_ => window.open(`${currentOrigin}/featuredartists/kemelyen`, '_blank' // <- This is what makes it open in a new window.
                        )}
                        style={{width: "27rem", minWidth: "200px"}}>
                        <p className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                            LEARN MORE
                        </p>
                    </button>
                </div>
            </div>
        </div>
        <Row justify={"center"} style={{
            backgroundColor: '#F0F0F0',
            padding: '2rem 8vw 0 8vw', display: "flex", flexDirection: "column", alignItems: "center"
        }}>
            <p className={'art-card-title'}>£600 Million Worth of Art!</p>
            <p className={'art-card-body'}>
                Unlock a world-class art collection valued at approximately £600 million, featuring masterpieces from
                renowned artists and emerging talents, all available at your fingertips through our app.
            </p>
        </Row>
        <div style={{padding: '4rem 8vw'}} className={'art-tab-container'}>
            <div className={'art-tab-nav'}>
                {artTabs.map((tab) => (
                    <button
                        key={tab.key}
                        type={'button'}
                        className={`art-tab-nav-button${activeTab === tab.key ? ' is-active' : ''}`}
                        onClick={() => handleTabChange(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            {activeTab === 'artists' ? (
                <>
                    <div
                        style={{display: 'flex', flexDirection: 'column', marginTop: '50px', alignItems: 'center'}}>
                        <p className={'art-card-title'}>Discover New <span
                            className={'art-card-title-bold'}>Artists.</span></p>
                        <p className={'art-card-body'}>Explore the expansive Vieunite art library and find images to
                            inspire you. From classic artwork to contemporary photography, the Vieunite collection
                            celebrates artistic
                            expression and offers users a wide variety of work to be displayed. From photos that
                            capture a
                            moment in time to moving artwork that brings peace to your space, Vieunite has got it
                            all!
                            Fresh work is constantly added to the library for you to choose from, so you are sure to
                            find
                            something you truly love.
                        </p>
                        <div style={{height: '30px'}}></div>
                        <button
                            className="homeMainButton black-border-hover-white"
                            onClick={openBrochure}
                            style={{width: "27rem", minWidth: "200px"}}>
                            <p className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                                ARTIST BROCHURE
                            </p>
                        </button>
                    </div>
                    <div ref={myRef} id='artists' style={{height: '40px'}}></div>
                    <div style={{width: '100%', padding: '40px'}}>
                        <p style={{width: '100%', textAlign: 'center'}}>
                            {filters.map((item) => {
                                // return (<span
                                //     className={filter === item ? 'art-filter-alphabet-selected' : 'art-filter-alphabet'}
                                //     onClick={() => filterArtistsByFirstLetter(item)}>{item}</span>)
                                if (activeCharacters.has(item)) {
                                    // console.log("item " + item + " is in set")
                                    return (<span
                                        key={item}
                                        className={filter === item ? 'art-filter-alphabet-selected' : 'art-filter-alphabet'}
                                        onClick={() => filterArtistsByFirstLetter(item)}>{item}</span>)
                                } else {
                                    // console.log("item " + item + " is not in set")
                                    return (<span key={item} className={'art-filter-alphabet-disable'}>{item}</span>)
                                }
                            })}
                        </p>
                    </div>

                    <div style={{
                        width: '100%', display: 'flex', flexWrap: "wrap", flexDirection: "row", padding: '1.5rem 0'
                    }}>
                        {artists.map((item) => {
                            return (<div key={item.path} style={{width: '25%', padding: '0.8vw'}}>
                                <div style={{width: '100%', borderRadius: '15px', overflow: 'hidden'}}>
                                    <img src={item.img}
                                         className={'art-artist-avatar'}
                                         onClick={_ => window.open(`${currentOrigin}${item.path}`, '_blank' // <- This is what makes it open in a new window.
                                         )}
                                    ></img>
                                </div>
                                <p className={'art-artist-name-label'}>{item.name}</p>
                            </div>)
                        })}
                    </div>
                </>
            ) : null}
                {activeTab === 'videos' ? (
                    <>
                    <div
                        style={{display: 'flex', flexDirection: 'column', marginTop: '50px', alignItems: 'center'}}>
                        <p className={'art-card-title'}>Artist and Gallery <span
                            className={'art-card-title-bold'}>Videos.</span></p>
                        <p className={'art-card-body'}>
                            At the heart of our collection is a dedicated collaborative ecosystem, where Vieunite
                            works hand-in-hand with a global community of artists. We build meaningful partnerships
                            with artists and galleries to ensure their creative intent is preserved and celebrated on
                            the Textura digital canvas. This is a window into those professional alliances,
                            showcasing work that reflect our shared commitment to bringing original art into corporate
                            spaces.
                        </p>
                    </div>
                    <div className={'art-videos-grid'}>
                        {videosList.map((video) => (
                            <button
                                key={video.name}
                                className={'art-video-card'}
                                onClick={() => openVideoModal(video)}
                                type={'button'}
                            >
                                <div className={'art-video-thumbnail-wrap'}>
                                    <img
                                        src={video.thumbnail}
                                        alt={video.name}
                                        className={'art-video-thumbnail'}
                                    />
                                </div>
                                <p className={'art-video-title'}>{video.title}</p>
                            </button>
                        ))}
                    </div>
                    </>
                ) : null}
                {activeTab === 'galleries' ? (
                    <>
                    <div
                        style={{display: 'flex', flexDirection: 'column', marginTop: '50px', alignItems: 'center'}}>
                        <p className={'art-card-title'}>Connecting You to <span
                            className={'art-card-title-bold'}>Galleries.</span></p>
                        <p className={'art-card-body'}>Explore the expansive Vieunite art library and find images to
                            inspire you. From classic artwork to contemporary photography, the Vieunite collection
                            celebrates artistic expression and offers users a wide variety of work to be displayed.
                            From photos that capture a moment in time to moving artwork that brings peace to your
                            space,
                            Vieunite has got it all! Fresh work is constantly added to the library for you to choose
                            from,
                            so you are sure to find something you truly love.
                        </p>
                    </div>
                    <div style={{height: '1.5rem'}}></div>

                    <div>
                        {galleryList.map((item, idx) => {
                            return (<div key={item.details} style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '10vh 0',
                                minHeight: '80vh'
                            }}>
                                <div ref={galleryRefs[idx]} style={{minWidth: '40vw', minHeight: '40vw'}}>
                                    {idx === 0 && // <Spring
                                        //     from={{opacity: 0}}
                                        //     to={{opacity: 1}}
                                        //     reset
                                        //     onRest={() => {
                                        //         // This changes the src after the fade-out is complete
                                        //         setSrc(toggle ? 'https://via.placeholder.com/300' : 'https://via.placeholder.com/150');
                                        //     }}
                                        // >
                                        //     {props => (
                                        //         <img src={imgSrc} style={{
                                        //             width: '40vw',
                                        //             borderRadius: '15px',
                                        //             position: isSticky ? 'fixed' : 'relative',
                                        //             top: isSticky ? '6rem' : 0,
                                        //             left: isSticky ? '9.6vw' : 0
                                        //         }}></img>
                                        //     )}
                                        // </Spring>

                                        <img alt="Switchable"
                                             className={`art-page-fade ${fade ? 'art-page-fade-out' : 'art-page-fade-in'}`}
                                             src={imageSrc}
                                             onMouseOver={() => onMouse(true)}
                                             onMouseOut={() => onMouse(false)}
                                             style={{
                                                 width: '40vw',
                                                 borderRadius: '15px', // position: 'sticky',
                                                 // top: '0'
                                                 position: isSticky ? 'fixed' : 'relative',
                                                 top: isSticky ? '6rem' : `${distance}px`,
                                             }}></img>}
                                </div>
                                <div className={'spacer'}/>
                                <div style={{maxWidth: '40vw'}}>
                                    <img src={item.logo}></img>
                                    <div style={{height: '35px'}}></div>
                                    <p className={'art-curation-body-label'}>{item.description}
                                    </p>
                                    <button className="homeMainButton black-border-hover-white"
                                            style={{width: "100%"}}
                                            onClick={_ => window.open(`${currentOrigin}${item.details}`, "_blank")}
                                    >
                                        <p className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                                            VIEW COLLECTION
                                        </p>
                                    </button>
                                    <div style={{height: '10px'}}></div>
                                    <button className="homeMainButton black-border-hover-white"
                                            style={{width: "100%"}}
                                            onClick={_ => window.open(item.website, "_blank")}>
                                        <p className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                                            VISIT GALLERY WEBSITE
                                        </p>
                                    </button>
                                </div>
                            </div>)
                        })}
                    </div>

                    </>
                ) : null}
                {activeTab === 'curation' ? (
                    <>
                    <div
                        style={{display: 'flex', flexDirection: 'column', marginTop: '50px', alignItems: 'center'}}>
                        <p className={'art-card-title art-card-title-bold'}>Art Tastemakers of the Highest
                            Order.</p>
                        <p className={'art-card-body'}>The Vieunite Curation Team is a powerhouse of art expertise,
                            blending the talents of artists, art historians, and researchers.
                            Our team has a proven track record of identifying and partnering with the most exciting
                            contemporary artists and unearthing the best visual culture from across the globe,
                            from fine art to intriguing archives of fashion, architecture, style, and more.
                        </p>
                        <p className={'art-card-body'}>
                            A passionate team of art explorers, we're dedicated to uncovering the best art from
                            around the world and sharing it with our users.
                            We believe that art has the power to transform lives, and we are dedicated to making it
                            accessible to everyone.
                        </p>
                        <div style={{height: '50px'}}></div>
                        <p className={'art-card-title art-card-title-bold'}>The Vieunite Curation Team: Where Art &
                            Expertise Meet</p>
                        <p className={'art-card-body'}>Our work at Vieunite is guided by two principles: that art is
                            for everyone,
                            and that art belongs everywhere, not just locked up in a museum.
                            Art is the basis for transformational experiences, and the powerful combination of our
                            curated library and next-level technology puts this within everyone’s budget.
                        </p>
                        <div style={{height: '50px'}}></div>

                        <p className={'art-card-title art-card-title-bold'}>Meet the Senior Team:</p>

                        <div style={{display: 'flex', flexDirection: 'row', flexWrap: "wrap"}}>
                            <div
                                style={{
                                    width: '33%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    minWidth: '300px',
                                    padding: '1rem',
                                }}>
                                <img src={ben} alt="Ben"/>
                                <p className={'art-page-curation-people-title'}>Dr Benedict Carpenter van Barthold -
                                    Cultural Director</p>
                                <p className={'art-page-curation-people-body'}>PhD in Art History, Graduate of the
                                    Royal College of Art, 25 years of experience in teaching art.
                                    Winner of the Jerwood Sculpture Prize. Expert in Contemporary Art</p>
                            </div>

                            <div
                                style={{
                                    width: '33%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    minWidth: '300px',
                                    padding: '1rem'
                                }}>
                                <img src={jane} alt="Jane"/>
                                <p className={'art-page-curation-people-title'}>Jane Elliot - Senior Librarian
                                </p>
                                <p className={'art-page-curation-people-body'}>Master of Art History from Edinburgh
                                    University.
                                    Formerly an editor at Sotheby's and Goodwill Art. Expert in the English
                                    Renaissance</p>
                            </div>
                            <div
                                style={{
                                    width: '33%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    minWidth: '300px',
                                    padding: '1rem'
                                }}>
                                <img src={aylwin} alt="Aylwin"/>
                                <p className={'art-page-curation-people-title'}>Aylwin Lambert - Senior Librarian
                                </p>
                                <p className={'art-page-curation-people-body'}>Master of Fine Art, PhD candidate.
                                    Practicing artist. Expert in Contemporary Art </p>
                            </div>
                        </div>

                        <div style={{height: '50px'}}></div>
                        <p className={'art-card-title art-card-title-bold'}>Our Expertise, Your Advantage</p>
                        <p className={'art-card-body'}>Our Cultural Director Dr. Benedict Carpenter van Barthold has
                            put together the Vieunite Curation team,
                            to bring a unique blend of artistic vision and academic rigour to crafting captivating
                            visual journeys.
                        </p>

                        <div style={{height: '50px'}}></div>
                        <div style={{display: 'flex', flexDirection: 'row', flexWrap: "wrap"}}>
                            <div style={{width: '48%'}} className={'art-page-curation-people-body'}>
                                <ul>
                                    <li><span style={{fontWeight: '700'}}>Diverse & Accomplished: </span>Our team
                                        comprises practising
                                        artists and seasoned art historians,
                                        each with a deep understanding of various art forms and periods.
                                        This breadth of knowledge ensures a collection that's both rich and
                                        relevant.
                                    </li>
                                    <div style={{height: '1rem'}}></div>
                                    <li><span style={{fontWeight: '700'}}>Curated
                                            with Purpose: </span>We understand the power of art to transform spaces and
                                        evoke emotions.
                                        That's why we meticulously group artworks into playlists that cater to
                                        specific moods, themes, or industries.
                                    </li>
                                </ul>
                            </div>
                            <div style={{height: '1rem'}}></div>
                            <div className={'art-page-curation-people-body'} style={{width: '48%'}}>
                                <ul>
                                    <li><span
                                        style={{fontWeight: '700'}}>Creativity Meets Scholarship: </span> Curating
                                        isn't just a selection process;
                                        it's an act of creative storytelling. Our team's combined artistic
                                        sensibilities and academic insights ensure that every piece is chosen with
                                        intention and meaning.
                                    </li>
                                    <div style={{height: '1rem'}}></div>
                                    <li><span style={{fontWeight: '700'}}>Uncompromising Quality: </span>We scour
                                        vast databases, libraries, and hidden art
                                        troves to bring you the highest-quality works from renowned galleries and
                                        emerging artists.
                                        Every piece is a testament to our commitment to excellence.
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div style={{height: '50px'}}></div>
                        <p className={'art-card-title art-card-title-bold'}>Playlists to Land your Message</p>
                        <p className={'art-card-body'}>From historic paintings to street style,
                            we've curated a vast library of visuals. But we don't just collect, we craft.
                            Our expertly arranged image playlists communicate your unique message with power and
                            precision.
                            Need something bespoke? We'll collaborate to create a seamless visual journey that
                            subtly guides or boldly declares – whatever tone you desire.
                            Because a playlist isn't just pictures, it's a story. Let's tell yours.
                        </p>

                        <div style={{height: '50px'}}></div>
                        <p className={'art-card-title art-card-title-bold'}>Discover the difference that curated art
                            can make.
                            Discover Vieunite.</p>
                    </div>
                    </>
                ) : null}
        </div>

        <Modal
            open={!!selectedVideo}
            footer={null}
            onCancel={closeVideoModal}
            destroyOnClose
            centered
            width={960}
            className={'art-video-modal'}
        >
            {selectedVideo ? (
                <div className={'art-video-modal-frame'}>
                    <iframe
                        src={selectedVideo.embedUrl}
                        title={`Artist Interview with ${selectedVideo.name}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </div>
            ) : null}
        </Modal>

        <div style={{height: '80px'}}></div>
    </div>)
}

export default ArtPage;
